import { lazy, type ComponentType, type LazyExoticComponent, type ReactElement } from "react";
import type { RouteObject } from "react-router-dom";
import { EVENT_MANAGEMENT_BROWSER_ROUTES } from "./browser.routes";

const EventCreationPage = lazy(() => import("../pages/EventCreation"));
const EventsRequestPage = lazy(() => import("../pages/EventsRequest"));
const EventsClonePage = lazy(() => import("../pages/EventsClone"));

type WithSuspense = (component: LazyExoticComponent<ComponentType>) => ReactElement;

export function getEventManagementRoutes(withSuspense: WithSuspense): RouteObject[] {
	return [
		{ path: EVENT_MANAGEMENT_BROWSER_ROUTES.EVENT_CREATION, element: withSuspense(EventCreationPage) },
		{ path: EVENT_MANAGEMENT_BROWSER_ROUTES.EVENTS_REQUEST, element: withSuspense(EventsRequestPage) },
		{ path: EVENT_MANAGEMENT_BROWSER_ROUTES.EVENTS_CLONE, element: withSuspense(EventsClonePage) },
	];
}
